import 'regenerator-runtime/runtime';
import Swiper from 'swiper';
import {Navigation, Pagination} from 'swiper/modules';
import 'jquery-validation';
import 'jquery-mask-plugin';
import 'select2';

import $ from 'jquery';

window.$ = $;
window.jQuery = $;

export {Swiper, Navigation, Pagination};
